export const ignoredSubjects = ['692136', '739613', '739612', '712901', '692139']

export const ignored2019Subjects = [
  '6834382',
  '6830282',
  '6828959',
  '6830281',
  '6828958',
  '6830280',
  '6830958',
  '6830957'
]
